import GameLayout from '@layouts/game-layout/game-layout';
export default GameLayout;
